// src/components/FacebookPixelTracker.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const FacebookPixelTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Ensure fbq is available before tracking
    if (window.fbq) {
      window.fbq('track', 'PageView');
      console.log('Facebook Pixel: PageView event fired for:', location.pathname);
    } else {
      console.warn('Facebook Pixel: fbq not found, PageView not tracked.');
    }
  }, [location]); // Re-run this effect whenever the location changes

  return null; // This component doesn't render any UI
};

export default FacebookPixelTracker;